module.exports = __webpack_public_path__ + "img/btn-fix-wallet-opend.465ea60c.png";